import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const layer0016 = new TileLayer({
  title: 'Máscara 20190903',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20190903l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0016.setVisible(false);
  
const layer0015 = new TileLayer({
  title: 'Máscara 20190911',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20190911l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0015.setVisible(false);
    
const layer0014 = new TileLayer({
  title: 'Máscara 20190927',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20190927l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0014.setVisible(false);
    
const layer0013 = new TileLayer({
  title: 'Máscara 20191021',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20191021l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0013.setVisible(false);
  
const layer0012 = new TileLayer({
  title: 'Máscara 20191208',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20191208l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0012.setVisible(false);
  
const layer0011 = new TileLayer({
  title: 'Máscara 20200101',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20200101l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0011.setVisible(false);
    
const layer0010 = new TileLayer({
  title: 'Máscara 20200210',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20200210l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0010.setVisible(false);
  
const layer009 = new TileLayer({
  title: 'Máscara 20200226',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20200226l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer009.setVisible(false);
  
const layer008 = new TileLayer({
  title: 'Máscara 20200524',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20200524l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer008.setVisible(false);
  
const layer007 = new TileLayer({
  title: 'Máscara 20200609',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20200609l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer007.setVisible(false);
  
const layer006 = new TileLayer({
  title: 'Máscara 20200617',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20200617l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer006.setVisible(false);
  
const layer005 = new TileLayer({
  title: 'Máscara 20200703',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20200703l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer005.setVisible(false);
  
const layer004 = new TileLayer({
  title: 'Máscara 20200711',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20200711l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer004.setVisible(false);
  
const layer003 = new TileLayer({
  title: 'Máscara 20200719',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20200719l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer003.setVisible(false);
  
const layer002 = new TileLayer({
  title: 'Máscara 20200727',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20200727l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer002.setVisible(false);
    
const layer001 = new TileLayer({
  title: 'Máscara 20200820',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20200820l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer001.setVisible(false);
    
const layer00 = new TileLayer({
  title: 'Máscara 20200828',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20200828l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00.setVisible(false);

export const grupoCapa01_2 = new LayerGroup({
  title: 'Ciclo Hidrológico 2019-2020',
  fold: 'close',
  layers: [layer00, layer001, layer002, layer003, layer004, layer005, layer006, layer007, layer008, layer009, layer0010, layer0011, layer0012, layer0013, layer0014, layer0015, layer0016]
});